import React from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { Link } from 'react-router-dom';
import './InformationRight.scss';

const InformationRight = () => {
  return (
    <div className="information-right-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="information-right-content">
              <h1 className="page-title mb-4">Bilgi Edinme Hakkı</h1>
              
              <div className="info-text">
                <h2 className="section-title mb-3">Bilgi Edinme Başvuru</h2>
                <p>
                  4982 Sayılı Bilgi Edinme Hakkı Kanunu ve Bilgi Edinme Hakkı Kanununun Uygulanmasına İlişkin 
                  Esas ve Usuller Hakkında Yönetmelik'i çerçevesinde oluşturulmuştur. Bilgi ve belgeye erişim 
                  işlerini yürütmektedir.
                </p>
                <p>
                  Belediyemiz web sitesinden veya bizzat başvuran herkes bu hizmetten yararlanabilir. E-posta 
                  yoluyla yapılan başvurularda T.C. Kimlik No kısmının doldurulması zorunludur. Telefonla başvuru 
                  kabul edilmemektedir.
                </p>
                <p>
                  Vatandaşlarımızın bilgi edinme hakkı kapsamında, Bilgi Edinme Kanunu'nunda geçen, 
                  <strong>Madde 27- Tavsiye ve mütalaa talepleri bu Kanun kapsamı dışındadır</strong> Kanun 
                  hükmünü göz önünde bulundurmaları gerekmektedir.
                </p>
                <p>
                  Başvurular ilgili müdürlüklere online veya yazılı olarak bildirilir. İstisnalar hariç 15 iş 
                  günü içerisinde çözümlenen talebin sonucu ilgili müdürlük tarafından vatandaşa talep ettiği 
                  şekilde bilgi verilir.
                </p>
              </div>

              <div className="application-buttons mt-5">
                <Link to="/bilgiedinmesahis" className="btn btn-primary">
                  <i className="pi pi-user me-2"></i>
                  Şahıs Başvurusu
                </Link>
                <Link to="/bilgiedinmekurum" className="btn btn-primary">
                  <i className="pi pi-building me-2"></i>
                  Kurum Başvurusu
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationRight;
